import { render, staticRenderFns } from "./svgbundle.vue?vue&type=template&id=d9296dd8&"
import script from "./svgbundle.vue?vue&type=script&lang=ts&"
export * from "./svgbundle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9296dd8')) {
      api.createRecord('d9296dd8', component.options)
    } else {
      api.reload('d9296dd8', component.options)
    }
    module.hot.accept("./svgbundle.vue?vue&type=template&id=d9296dd8&", function () {
      api.rerender('d9296dd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/svgbundle.vue"
export default component.exports